// src/services/moduleService.js
import { apiClient, adminApiClient } from "./apiClient";

// --------------------
// Safe normalize helper
// --------------------
const normalizeArray = (res) => {
  if (!res) return [];
  const d = res.data;

  // Already an array
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;

  // If it's a single object (like announcements), wrap in array
  if (d && typeof d === "object") return [d];

  return [];
};


// --------------------
// Announcements
// --------------------
export const getAnnouncements = async (sourceId, metadata = {}) => {
  try {
    //console.log(`[API CALL] GET /announcements/${sourceId}`, metadata);
    const res = await apiClient.get(`/announcements/${sourceId}`);
    //console.log(`[API RAW] Announcements response`, res.data); 
    const data = normalizeArray(res);

    const mapped = data.map((a) => ({
      id: a.id,
      title: a.title || "",
      description: a.description?.trim() || "",
      imageLink: a.imageLink || "",
      ...metadata, // attach config metadata
    }));

    // console.log(`[API SUCCESS] Announcements fetched`, {
    //   sourceId,
    //   count: mapped.length,
    //   sample: mapped[0] || null,
    // });

    return mapped;
  } catch (err) {
    console.error(`[API ERROR] Announcements ${sourceId}:`, err.message);
    return [];
  }
};

// --------------------
// Events
// --------------------
export const getCommunityEvents = async (sourceId, metadata = {}) => {
  try {
    //console.log(`[API CALL] GET /CommunityEvent/${sourceId}`, metadata);
    const res = await apiClient.get(`/CommunityEvent/${sourceId}`);
    const data = normalizeArray(res);

    const mapped = data.map((e) => ({
      id: e.id,
      name: e.name || "",
      description: e.description?.trim() || "",
      images: e.images || [],
      location: e.location || "",
      masjid_Name: e.masjid_Name || "",
      city_Name: e.city_Name || "",
      state_Name: e.state_Name || "",
      country_Name: e.country_Name || "",
      ...metadata,
    }));

    // console.log(`[API SUCCESS] Community events fetched`, {
    //   sourceId,
    //   count: mapped.length,
    //   sample: mapped[0] || null,
    // });

    return mapped;
  } catch (err) {
    console.error(`[API ERROR] Community events ${sourceId}:`, err.message);
    return [];
  }
};

// --------------------
// Images
// --------------------
export const getImages = async (sourceId, metadata = {}) => {
  try {
    //console.log(`[API CALL] GET /Display_Images/${sourceId}`, metadata);
    const res = await adminApiClient.get(`/Display_Images/${sourceId}`);
    const data = normalizeArray(res);

    const mapped = data.map((img) => ({
      ...img,
      ...metadata,
    }));

    // console.log(`[API SUCCESS] Images fetched`, {
    //   sourceId,
    //   count: mapped.length,
    //   sample: mapped[0] || null,
    // });

    return mapped;
  } catch (err) {
    console.error(`[API ERROR] Images ${sourceId}:`, err.message);
    return [];
  }
};

// --------------------
// Iqama Screen
// --------------------
export const getIqamaScreen = async (sourceId, metadata = {}) => {
  try {
    //console.log(`[API CALL] GET /Display_Iqama_Screen/${sourceId}`, metadata);
    const res = await adminApiClient.get(`/Display_Iqama_Screen/${sourceId}`);

    const mapped = { ...(res.data || {}), ...metadata };

    // console.log(`[API SUCCESS] Iqama screen fetched`, {
    //   sourceId,
    //   keys: Object.keys(mapped),
    // });

    return mapped;
  } catch (err) {
    console.error(`[API ERROR] Iqama screen ${sourceId}:`, err.message);
    return {};
  }
};


// --------------------
// Dispatcher
// --------------------
export const getModuleData = async (mod) => {
  if (!mod) return null;

  const moduleName = mod.source_Module_Name?.toLowerCase();
  const sourceId = mod.source_Module_Id;

  if (!moduleName || !sourceId) {
    console.warn("Invalid module config:", mod);
    return null;
  }

  // extract metadata from the innermost config object
  const metadata = {
    id: mod.id || null,
    display_Id: mod.display_Id || null,
    location: mod.location || null,
    duration: mod.duration || null,
    active: mod.active ?? null,
  };

  switch (moduleName) {
    case "announcements":
      return await getAnnouncements(sourceId, metadata);
    case "events":
    case "communityevents":
      return await getCommunityEvents(sourceId, metadata);
    case "images":
      return await getImages(sourceId, metadata);
    case "iqama":
    case "iqamascreen":
      return await getIqamaScreen(sourceId, metadata);
    default:
      console.warn(`Unknown module: ${moduleName}`);
      return null;
  }
};
